export default {"src":"/_next/static/media/blueicon.6bb8d9b5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};